import EventTarget, { defineEventAttribute } from 'event-target-shim';

export default EventTarget;
export { defineEventAttribute, EventTarget };
